import './ReactotronConfig'
import React from 'react';
// IMPORTACIÓN CLAVE: Cambiamos a la API de cliente de React DOM
import * as ReactDOM from 'react-dom/client'; 
import App from './App.jsx';
import store from './Store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';

// 1. Obtener el elemento raíz
const container = document.getElementById('root');

// 2. Crear la raíz (root)
const root = ReactDOM.createRoot(container);

// 3. Renderizar usando root.render
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

serviceWorker.unregister();